export enum CalendarSyncRowSizingMode {
  RealSize = 1,
  AutoScale = 2,
}
